import classnames from 'classnames/bind'
import { isEmpty, trim } from 'lodash'
import Modal from 'react-overlays/lib/Modal'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MdClose } from 'react-icons/md'
import DirectIntroductionClient from 'clients/cooperation/direct_introduction_client'
import FormGroup from 'components/form_group'
import SelectableButtons from 'components/selectable_buttons'
import Toast from 'components/toast'
import Company from 'entities/company'
import Group from 'entities/group'
import Offer from 'entities/offer'
import Recruiter from 'entities/recruiter'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import { setModalStyleOnMobileWidth } from 'supports/modal_style_helper'
import DirectIntroductionIntroducerSelector from './direct_introduction_introducer_selector'
import styles from './direct_introduction_form.module.scss'

const cx = classnames.bind(styles)
export default class DirectIntroductionForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      candidateName: null,
      company: new Company(props.company),
      culture: null,
      offer: new Offer(props.offer),
      error: null,
      group: new Group(props.group),
      searchGroup: new Group(props.searchGroup),
      introducer: props.introducer ? new Recruiter(props.introducer) : null,
      motivation: null,
      reason: null,
      sending: false,
      show: props.showModal,
      skill: null,
      prevPropsShow: props.showModal,
      onClose: props.onClose
    }

    this.options = props.statuses.map(option => ({
      label: I18n.t(`cooperation.direct_introduction.motivation_to_change_job.${option[1]}`),
      value: option[0]
    }))
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showModal !== prevState.prevPropsShow) {
      return {
        show: nextProps.showModal,
        candidateName: null,
        culture: null,
        error: null,
        motivation: null,
        reason: null,
        sending: false,
        skill: null,
        prevPropsShow: nextProps.showModal
      }
    }
    return null
  }

  show() {
    this.setState({
      show: true
    })
  }

  hide() {
    const { onClose } = this.state

    this.setState({
      candidateName: null,
      culture: null,
      error: null,
      motivation: null,
      reason: null,
      sending: false,
      show: false,
      skill: null
    })
    onClose()
  }

  handleUpdateIntroducer(introducer) {
    this.setState(
      {
        introducer: introducer || null
      },
      () => setModalStyleOnMobileWidth(this.modal)
    )
  }

  handleChangeCulture(value) {
    this.setState({
      culture: value
    })
  }

  handleChangeSkill(value) {
    this.setState({
      skill: value
    })
  }

  handleChangeSelector(value) {
    this.setState({
      motivation: isEmpty(value) ? null : parseInt(value, 10)
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { contentId } = this.props
    const { candidateName, company, culture, group, introducer, motivation, offer, reason, skill } = this.state

    this.setState({
      sending: true
    })

    const params = {
      token_company: company.token,
      token_group: group.token,
      token_offer: offer.token,
      token_recruiter: introducer ? introducer.token : null,
      direct_introduction: {
        candidate_name: candidateName,
        reason,
        skill,
        culture,
        motivation_to_change_job: motivation
      },
      content_id: contentId
    }

    return DirectIntroductionClient.post(params)
      .then(() => {
        Toast.notify(I18n.t('offers.pages.direct_introduction_form.message.introduction.complete'))
        this.hide()
      })
      .catch(error => {
        Toast.notify(I18n.t('offers.pages.direct_introduction_form.message.introduction.failure'))
        this.setState(
          {
            error,
            sending: false
          },
          () => setModalStyleOnMobileWidth(this.modal)
        )
      })
  }

  render() {
    const { deviceName, selectable } = this.props
    const {
      company,
      culture,
      error,
      searchGroup,
      candidateName,
      introducer,
      motivation,
      offer,
      reason,
      sending,
      show,
      skill
    } = this.state

    return (
      <Modal show={show}>
        <div className={styles.modal}>
          <div className={styles.modalInner}>
            <div className={styles.modalHeader}>
              <span>{I18n.t('offers.pages.direct_introduction_form.modal.title')}</span>
              <button type="button" className={cx(styles.button, styles.closeButton)} onClick={() => this.hide()}>
                <MdClose size={24} />
              </button>
            </div>
            <div className={styles.modalContent}>
              <form onSubmit={e => this.handleSubmit(e)}>
                <div className={styles.formContainer}>
                  <div className="form-group">
                    <div className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.position')}
                    </div>
                    <div className="form-group-content">
                      <div className="value">{offer.position}</div>
                    </div>
                  </div>
                  <FormGroup error={error} name="cooperation.recruiter_id">
                    <label htmlFor="direct_introduction_recruiter" className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.recruiter.label')}
                    </label>
                    <DirectIntroductionIntroducerSelector
                      introducer={introducer}
                      companyToken={company.token}
                      offerToken={offer.token}
                      groupToken={searchGroup.token}
                      selectable={selectable}
                      deviceName={deviceName}
                      onUpdate={newIntroducer => this.handleUpdateIntroducer(newIntroducer)}
                    />
                  </FormGroup>
                  <FormGroup error={error} name="candidate_name">
                    <label className="form-group-label" htmlFor="direct_introduction_candidate_name">
                      {I18n.t('offers.pages.direct_introduction_form.modal.candidate.label')}
                    </label>
                    <div className="form-group-content">
                      <input
                        type="text"
                        name="direct_introduction[candidate_name]"
                        id="direct_introduction_candidate_name"
                        defaultValue={candidateName}
                        className="form-control"
                        placeholder={I18n.t('offers.pages.direct_introduction_form.modal.candidate.placeholder')}
                        onChange={e => this.setState({ candidateName: trim(e.target.value) })}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup error={error} name="skill">
                    <div className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.skill.label')}
                    </div>
                    <div className="form-group-content">
                      <SelectableButtons
                        ltr={I18n.t('offers.pages.direct_introduction_form.modal.skill.ltr')}
                        name="skill"
                        selected={skill}
                        rtl={I18n.t('offers.pages.direct_introduction_form.modal.skill.rtl')}
                        onClick={value => this.handleChangeSkill(value)}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup error={error} name="culture">
                    <div className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.culture.label')}
                    </div>
                    <div className="form-group-content">
                      <SelectableButtons
                        ltr={I18n.t('offers.pages.direct_introduction_form.modal.culture.ltr')}
                        name="culture"
                        selected={culture}
                        rtl={I18n.t('offers.pages.direct_introduction_form.modal.culture.rtl')}
                        onClick={value => this.handleChangeCulture(value)}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup error={error} name="motivation_to_change_job">
                    <label htmlFor="direct_introduction_status" className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.introduction_status.label')}
                    </label>
                    <div className="form-group-content">
                      <div className="select-field">
                        <select
                          className="form-control"
                          name="motivation"
                          disabled={sending}
                          onChange={e => this.handleChangeSelector(e.target.value)}
                        >
                          <option value="">
                            {I18n.t('offers.pages.direct_introduction_form.modal.introduction_status.option_top')}
                          </option>
                          {this.options.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        <div className="caret" />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup error={error} name="reason">
                    <label htmlFor="direct_introduction_reason" className="form-group-label">
                      {I18n.t('offers.pages.direct_introduction_form.modal.reason.label')}
                    </label>
                    <div className="form-group-content">
                      <textarea
                        id="direct_introduction_reason"
                        name="direct_introduction[reason]"
                        className="form-control"
                        defaultValue={reason}
                        rows="5"
                        onChange={e => this.setState({ reason: trim(e.target.value) })}
                      />
                    </div>
                  </FormGroup>
                </div>

                <div className={styles.submitContainer}>
                  <input
                    type="submit"
                    className={cx(styles.button, styles.buttonSubmit)}
                    value={
                      sending
                        ? I18n.t('offers.pages.direct_introduction_form.button.sending')
                        : I18n.t('offers.pages.direct_introduction_form.button.introduction.to_manager')
                    }
                    disabled={
                      isEmpty(introducer) ||
                      isEmpty(candidateName) ||
                      skill === null ||
                      culture === null ||
                      motivation === null ||
                      isEmpty(reason) ||
                      sending
                    }
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

DirectIntroductionForm.propTypes = {
  contentId: PropTypes.number,
  company: propTypeInstantiableTo(Company).isRequired,
  offer: propTypeInstantiableTo(Offer).isRequired,
  deviceName: PropTypes.string.isRequired,
  group: propTypeInstantiableTo(Group).isRequired,
  searchGroup: propTypeInstantiableTo(Group).isRequired,
  introducer: propTypeInstantiableTo(Recruiter),
  selectable: PropTypes.bool.isRequired,
  statuses: PropTypes.arrayOf(PropTypes.array).isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

DirectIntroductionForm.defaultProps = {
  contentId: null,
  introducer: null
}
